import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { message } from "antd";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Fade,
  Slide,
} from "@mui/material";

const UpdatePostRouter = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [code, setCode] = useState("");

  useEffect(() => {
    const numericId = Number(id);
    const fetchPost = async () => {
      try {
        const res = await axios.get(
          `https://uktomars.co.uk/api/posts/${numericId}`
        );
        const item = res?.data;
        setCode(item?.code || "");
      } catch (error) {
        if (error?.response?.status === 404) {
          try {
            const listRes = await axios.get(`https://uktomars.co.uk/api/posts`);
            const items = Array.isArray(listRes?.data) ? listRes.data : [];
            const found = items.find((p) => Number(p.id) === numericId);
            if (found) {
              setCode(found.code || "");
              return;
            }
            message.error("Post not found");
          } catch (listError) {
            console.error("Error fetching posts list:", listError);
            message.error("Failed to load post");
          }
        } else {
          console.error("Error fetching post:", error);
          message.error("Failed to load post");
        }
      }
    };
    if (!Number.isNaN(numericId)) {
      fetchPost();
    }
  }, [id]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) {
      message.error("Please input product code!");
      return;
    }

    try {
      const updatedValues = {
        code: code.trim(),
      };

      const response = await axios.put(
        `https://uktomars.co.uk/api/posts/${id}`,
        updatedValues
      );

      if (response.status === 200) {
        message.success("Successfully updated");
        navigate("/PostGetRouter");
      }
    } catch (error) {
      console.error("Error updating post:", error);
      message.error("Failed to update");
    }
  };

  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ maxWidth: 800, mx: "auto", my: 5, px: 2 }}>
        <Slide direction="up" in={true} timeout={400}>
          <Paper elevation={6} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
            <Box component="form" onSubmit={onSubmit}>
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  Update Product Code
                </Typography>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    label="Product Code"
                    placeholder="Enter product code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    required
                    sx={{
                      width: 300,
                      "& .MuiOutlinedInput-root": { borderRadius: 2 },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", gap: 2, justifyContent: "center" }}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      // disabled={submitting}
                      sx={{
                        backgroundColor: "#3A6F43",
                        "&:hover": { backgroundColor: "#3A6F43" },
                      }}
                    >
                      Save Changes
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => navigate("/PostGetRouter")}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Slide>
      </Box>
    </Fade>
  );
};

export default UpdatePostRouter;
